var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFifthCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 452,
    viewBox: "0 0 422 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2401_8929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 422,
    height: 452
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 452,
    rx: 42,
    fill: "white",
    fillOpacity: 0.72
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 421,
    height: 451,
    rx: 41.5,
    stroke: "#FECBFF",
    strokeOpacity: 0.4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2401_8929)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M224.323 11H194.094V41.229H224.323V11Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.486 380.918H67.6758V421.729H108.486V380.918Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.566 179.14H236.331C234.835 179.14 233.621 177.927 233.621 176.43V158.31C233.621 156.813 234.834 155.6 236.331 155.6H240.566C242.063 155.6 243.276 156.813 243.276 158.31V176.43C243.276 177.927 242.063 179.14 240.566 179.14Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.907 170.218C269.234 173.374 266.587 173.567 266.587 173.567C266.587 173.567 268.609 174.657 268.139 176.502C267.669 178.348 265.943 179.139 264.487 179.139H252.689C250.744 179.139 248.809 178.761 247.036 177.96C246.921 177.908 246.809 177.859 246.7 177.813C245.967 177.502 245.5 176.775 245.5 175.979V158.87C245.5 158.074 245.697 157.294 246.07 156.59C246.885 155.054 248.286 152.188 248.286 150.649C248.286 148.479 245.259 141.871 247.548 140.428C249.788 139.015 253.233 141.144 254.361 144.063C255.489 146.981 254.795 152.741 255.88 153.826H267.309C267.309 153.826 270.555 153.679 270.471 156.936C270.407 159.401 268.68 160.443 268.68 160.443C268.68 160.443 271.015 160.822 270.751 163.449C270.456 166.39 268.33 167.169 268.33 167.169C268.33 167.169 270.391 167.947 269.907 170.218Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.847 375.396H347.07C344.675 375.396 342.734 373.455 342.734 371.06V342.063C342.734 339.668 344.675 337.727 347.07 337.727H353.847C356.242 337.727 358.183 339.668 358.183 342.063V371.06C358.183 373.455 356.242 375.396 353.847 375.396Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.797 361.12C399.72 366.17 395.484 366.48 395.484 366.48C395.484 366.48 398.72 368.225 397.967 371.176C397.214 374.13 394.453 375.396 392.123 375.396H373.243C370.13 375.396 367.033 374.791 364.196 373.509C364.012 373.426 363.832 373.347 363.659 373.274C362.486 372.776 361.738 371.614 361.738 370.339V342.959C361.738 341.685 362.052 340.436 362.649 339.31C363.953 336.851 366.195 332.266 366.195 329.803C366.195 326.331 361.35 315.756 365.014 313.446C368.599 311.186 374.111 314.591 375.916 319.262C377.72 323.932 376.61 333.149 378.346 334.885H396.635C396.635 334.885 401.83 334.65 401.695 339.861C401.593 343.805 398.83 345.473 398.83 345.473C398.83 345.473 402.566 346.079 402.145 350.283C401.673 354.989 398.27 356.236 398.27 356.236C398.27 356.236 401.573 357.485 400.797 361.12Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1664 356.581H85.0564C83.9574 356.581 83.0664 355.69 83.0664 354.591V341.287C83.0664 340.188 83.9574 339.297 85.0564 339.297H88.1664C89.2654 339.297 90.1564 340.188 90.1564 341.287V354.591C90.1564 355.691 89.2654 356.581 88.1664 356.581Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.71 350.031C109.216 352.348 107.272 352.49 107.272 352.49C107.272 352.49 108.757 353.291 108.412 354.645C108.066 356 106.799 356.581 105.731 356.581H97.0681C95.6391 356.581 94.2191 356.303 92.9171 355.715C92.8321 355.677 92.7501 355.641 92.6701 355.607C92.1321 355.379 91.7891 354.845 91.7891 354.261V341.698C91.7891 341.113 91.9331 340.541 92.2071 340.024C92.8051 338.896 93.8341 336.792 93.8341 335.662C93.8341 334.069 91.6111 329.217 93.2921 328.157C94.9371 327.12 97.4661 328.683 98.2941 330.826C99.1221 332.969 98.6121 337.198 99.4091 337.994H107.801C107.801 337.994 110.184 337.886 110.123 340.277C110.076 342.087 108.808 342.852 108.808 342.852C108.808 342.852 110.522 343.13 110.329 345.059C110.113 347.218 108.551 347.79 108.551 347.79C108.551 347.79 110.066 348.364 109.71 350.031Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8273 198.251C91.0662 190.651 85.9096 183.486 78.3098 182.247C70.7099 181.008 63.5447 186.165 62.3058 193.765C61.0668 201.364 66.2234 208.53 73.8233 209.769C81.4231 211.008 88.5884 205.851 89.8273 198.251Z",
    fill: "#EEBD56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9275 200.479C82.9275 200.479 81.5385 204.341 76.0575 204.341C70.5765 204.341 69.1875 200.479 69.1875 200.479",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8359 192.868C67.8359 192.868 70.0859 192.341 71.7139 194.16",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2803 192.868C84.2803 192.868 82.0303 192.341 80.4023 194.16",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.272 50.3956C390.811 50.3956 398.544 42.6626 398.544 33.1236C398.544 23.5845 390.811 15.8516 381.272 15.8516C371.733 15.8516 364 23.5845 364 33.1236C364 42.6626 371.733 50.3956 381.272 50.3956Z",
    fill: "#EEBD56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.783 38.6641C389.783 38.6641 388.063 43.4481 381.273 43.4481C374.483 43.4481 372.762 38.6641 372.762 38.6641",
    stroke: "black",
    strokeWidth: 1.2388,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.086 29.2341C371.086 29.2341 373.873 28.5821 375.89 30.8351",
    stroke: "black",
    strokeWidth: 1.2388,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.456 29.2341C391.456 29.2341 388.669 28.5821 386.652 30.8351",
    stroke: "black",
    strokeWidth: 1.2388,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.71 110.453H50.2281C44.4621 110.453 39.7891 115.127 39.7891 120.892V139.315C39.7891 145.081 44.4631 149.754 50.2281 149.754H110.266L126.151 165.639V120.892C126.15 115.127 121.476 110.453 115.71 110.453Z",
    fill: "#7ABDE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6602 119.766H113.255",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6602 129.66H113.255",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6602 139.553H99.3402",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.192 307.65H42.612C40.065 307.65 38 305.585 38 303.038V263.783C38 261.236 40.065 259.17 42.612 259.17H85.192C87.739 259.17 89.804 261.235 89.804 263.783V303.038C89.805 305.585 87.74 307.65 85.192 307.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7003 281.21L57.5463 268.94C55.7823 267.748 53.4023 269.012 53.4023 271.141V295.682C53.4023 297.811 55.7823 299.075 57.5463 297.883L75.7003 285.613C77.2583 284.558 77.2583 282.263 75.7003 281.21Z",
    fill: "#CC3B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.961 85.0412H154.92C147.094 85.0412 140.75 78.6972 140.75 70.8712C140.75 63.0452 147.094 56.7012 154.92 56.7012H258.961C266.787 56.7012 273.131 63.0452 273.131 70.8712C273.131 78.6972 266.787 85.0412 258.961 85.0412Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.812 77.7698L166.642 74.5998C168.883 71.0638 168.469 66.3168 165.388 63.2358C161.821 59.6688 156.017 59.6688 152.449 63.2358C148.882 66.8028 148.882 72.6068 152.449 76.1748C155.53 79.2558 160.277 79.6698 163.813 77.4288L166.982 80.5988C167.763 81.3798 169.03 81.3798 169.81 80.5988C170.593 79.8168 170.593 78.5508 169.812 77.7698ZM155.279 73.3458C153.271 71.3378 153.271 68.0718 155.279 66.0638C157.287 64.0558 160.553 64.0558 162.561 66.0638C164.569 68.0718 164.569 71.3378 162.561 73.3458C160.553 75.3538 157.287 75.3538 155.279 73.3458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.473 71.8096C238.729 70.5796 241.196 69.3586 244.874 68.7016C252.023 67.4246 256.363 75.7676 260.576 74.8516",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.938 72.2748C175.938 72.2748 183.644 66.4578 188.576 66.4028C195.853 66.3218 198.278 77.8918 203.512 78.0198C208.746 78.1478 213.406 67.1688 219.725 68.4458C225.191 69.5498 222.385 76.8898 229.81 74.8508C230.64 74.6228 231.403 74.3488 232.126 74.0418",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7459 70.6727C86.5259 72.8297 83.5279 75.8277 81.3719 87.0467C81.1679 88.1097 79.6409 88.1097 79.4369 87.0467C77.2799 75.8267 74.2819 72.8287 63.0629 70.6727C61.9999 70.4687 61.9999 68.9427 63.0629 68.7377C74.2829 66.5807 77.2809 63.5827 79.4369 52.3637C79.6409 51.3007 81.1679 51.3007 81.3719 52.3637C83.5279 63.5837 86.5259 66.5817 97.7459 68.7377C98.8089 68.9417 98.8089 70.4687 97.7459 70.6727Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.302 105.59C283.138 107.159 280.957 109.341 279.387 117.505C279.238 118.278 278.128 118.278 277.979 117.505C276.41 109.341 274.228 107.16 266.064 105.59C265.291 105.441 265.291 104.331 266.064 104.182C274.228 102.613 276.409 100.431 277.979 92.2673C278.128 91.4942 279.238 91.4942 279.387 92.2673C280.956 100.431 283.138 102.613 291.302 104.182C292.075 104.331 292.075 105.441 291.302 105.59Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.879 309.529C333.216 310.352 331.982 311.587 331.158 315.25C331.021 315.859 330.151 315.859 330.014 315.25C329.191 311.587 327.957 310.352 324.293 309.529C323.684 309.392 323.684 308.522 324.293 308.385C327.956 307.562 329.191 306.327 330.014 302.664C330.151 302.055 331.022 302.055 331.158 302.664C331.981 306.327 333.216 307.562 336.879 308.385C337.489 308.521 337.489 309.392 336.879 309.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.925 41.1615V219.659H78.097V41.1615H264.925ZM266.022 40.0645H77V220.755H266.021L266.022 40.0645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24 53.2129H87.7812V207.608H255.24V53.2129Z",
    fill: "#B5B5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7812 153.451L123.492 101.019C131.697 88.9722 149.181 88.2032 158.412 99.4842L216.643 170.649L255.241 121.247V207.607H87.7812V153.451Z",
    fill: "#B5B5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.554 118C229.501 118 239.186 108.315 239.186 96.3683C239.186 84.4213 229.501 74.7363 217.554 74.7363C205.607 74.7363 195.922 84.4213 195.922 96.3683C195.922 108.315 205.607 118 217.554 118Z",
    fill: "#B5B5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.406 352.613L336.725 321.627L313.668 333.057L336.516 363.343L355.406 352.613Z",
    fill: "#CE623A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.994 333.691L326.034 349.451L313.664 333.061L336.724 321.631L343.994 333.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.563 197.859L285.256 238.272C294.219 243.545 301.528 251.219 306.359 260.427L344.005 332.19L313.672 349.169C313.672 349.169 279.964 304.905 271.75 290.573C265.75 280.105 267.154 272.956 267.154 272.956L206.59 238.271L216.563 197.859Z",
    fill: "#EEBD56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.446 247.971C293.446 254.001 279.776 275.861 276.436 298.001C274.486 295.081 272.876 292.541 271.746 290.571C265.746 280.111 267.156 272.961 267.156 272.961L206.586 238.271L216.566 197.861L285.256 238.271C289.776 240.931 293.866 244.201 297.446 247.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.15 238.273H137.703V246.341H231.15V238.273Z",
    fill: "#802223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.15 325.354H137.703V333.422H231.15V325.354Z",
    fill: "#802223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.792 374.064H122.641L148.556 246.34H158.513L139.792 374.064Z",
    fill: "#802223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.216 374.064H229.065L210.344 246.34H220.301L246.216 374.064Z",
    fill: "#802223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.513 246.342L157.413 253.862H147.023L148.553 246.342H158.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.834 253.862H211.444L210.344 246.342H220.304L221.834 253.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.026 325.354L145.75 333.422H150.216L148.748 325.354H147.026Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.062 306.049L219.697 281.287L238.176 296.511L223.001 311.842L202.062 306.049Z",
    fill: "#CE623A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.175 296.511L227.855 306.931L212.895 290.831L219.695 281.291L238.175 296.511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.754 310.202L213.387 289.63C213.387 289.63 231.59 259.764 243.153 244.873C251.579 234.022 256.174 229.299 256.174 229.299L206.589 238.274H150.562C126.611 230.988 138.573 189.529 138.573 189.529C138.573 189.529 141.292 189.04 146.076 188.279H289.018C296.158 188.279 303.825 189.979 308.588 195.298C316.818 204.49 316.604 220.972 305.549 234.967C280.174 267.085 240.754 310.202 240.754 310.202Z",
    fill: "#EEBD56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.43 212.222C139.43 212.222 150.153 219.371 173.643 214.265C197.132 209.159 215.132 199.84 215.132 199.84L212.706 193.84C212.706 193.84 224.706 193.712 225.855 188.734L203.132 187.84L139.43 212.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.385 311.204C195.266 312.574 194.508 313.656 194.508 313.656L236.606 355.846C236.606 355.846 237.915 355.275 238.906 353.819C239.713 352.674 240.316 350.971 239.902 348.573C238.328 339.379 223 311.842 223 311.842L202.062 306.049C200.194 306.853 197.943 309.297 196.385 311.204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.385 311.203C195.155 311.796 194.219 313.364 194.219 313.364L236.924 356.162C236.924 356.162 238.695 355.431 238.906 353.816L196.385 311.203Z",
    fill: "#D390BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.885 326.809C230.885 326.809 228.107 327.675 224.766 329.387",
    stroke: "#D390BB",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.53 320.27C227.53 320.27 224.612 321.277 221.27 322.988",
    stroke: "#D390BB",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.157 371.003C336.337 372.763 336.567 374.063 336.567 374.063H396.167C396.167 374.063 396.687 372.733 396.357 371.003C396.117 369.623 395.337 367.993 393.347 366.593C385.727 361.213 355.407 352.613 355.407 352.613L336.517 363.343C335.767 365.233 335.907 368.553 336.157 371.003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.157 371.004C335.708 372.294 336.157 374.064 336.157 374.064H396.617C396.617 374.064 397.351 372.294 396.357 371.004H336.157Z",
    fill: "#D390BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.572 357.604C371.572 357.604 370.223 360.182 369.074 363.756",
    stroke: "#D390BB",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.572 355.359C364.572 355.359 363.223 358.136 362.074 361.71",
    stroke: "#D390BB",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.958 188.277H223.176V183.084H314.96L311.958 188.277Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.598 188.281L283.463 138.415C285.274 135.287 288.614 133.361 292.228 133.361H338.737C341.316 133.361 342.927 136.155 341.635 138.387L312.754 188.281",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.365 187.17C157.365 187.17 150.216 210.659 168.088 220.872C182.801 229.279 278.131 217.042 278.131 217.042L221.269 290.574",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.177 179.884C223.177 179.884 208.085 123.619 202.874 110.126C199.929 102.502 191.551 91.5151 177.105 94.5091C177.105 94.5091 176.866 94.5651 176.445 94.6691C174.567 95.1641 174.155 91.2852 174.155 91.2852C167.609 90.2132 157.62 92.1921 157.62 92.1921C157.114 99.5101 151.496 103.046 149.414 104.112C149.179 104.221 148.946 104.332 148.712 104.443C148.679 104.457 148.644 104.472 148.644 104.472L148.656 104.471C142.631 107.328 136.763 110.78 132.336 114.812C117.76 128.087 110.472 195.763 124.267 207.736C142.796 223.818 208.602 195.242 208.602 195.242L204.177 179.885H223.177V179.884Z",
    fill: "#D390BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.895 116.957C198.682 125.638 201.618 143.127 205.321 163.202",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.238 276.979L318.216 341.319",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.932 190.436L202.047 173.262C202.047 173.262 216.279 168.755 223.669 167.016C228.915 165.782 246.703 171.123 249.017 175.92C251.123 176.59 253.876 177.619 253.876 177.619C253.876 177.619 256.626 179.149 256.599 181.298C256.58 182.751 255.743 183.085 255.743 183.085H236.023C236.023 183.085 235.412 185.326 230.63 188.586C225.849 191.847 212.252 187.937 206.932 190.436Z",
    fill: "#CE623A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.516 175.616C230.516 175.616 234.442 173.861 237.314 174.052C240.186 174.243 248.468 175.919 248.468 175.919",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.738 170.511C227.738 170.511 230.802 169.506 232.828 169.314C234.36 169.169 238.62 170.128 238.62 170.128",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.155 177.187C156.919 174.865 154.301 148.936 154.301 142.17C154.301 142.17 153.483 164.011 154.24 177.882C153.254 178.145 152.451 178.397 151.875 178.635C144.726 181.59 141.535 184.233 141.535 184.233L200.897 170.51C200.897 170.51 170.607 174.251 157.155 177.187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.294 60.9417C155.707 68.0477 154.193 79.9187 164.599 86.2657C174.22 92.1347 186.368 83.5577 185.489 69.3077C184.787 57.9437 169.464 50.5507 161.294 60.9417Z",
    fill: "#CE623A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.689 62.3795C189.689 59.3545 187.511 56.8435 184.638 56.3175C184.702 56.1465 184.742 55.9635 184.742 55.7705C184.742 54.9105 184.045 54.2145 183.186 54.2145C182.853 54.2145 182.547 54.3205 182.294 54.4985C181.311 52.2815 179.094 50.7335 176.513 50.7335C175.82 50.7335 175.155 50.8485 174.532 51.0545C173.546 49.8735 172.082 49.1055 170.423 49.1055C168.72 49.1055 167.22 49.9135 166.236 51.1495C165.23 50.5295 164.049 50.1665 162.78 50.1665C159.13 50.1665 156.172 53.1255 156.172 56.7745C156.172 57.3135 156.244 57.8355 156.366 58.3375C154.905 58.5865 153.791 59.8505 153.791 61.3825C153.791 61.9165 153.939 62.4115 154.176 62.8505C153.856 62.9835 153.566 63.1685 153.294 63.3765C153.243 63.4105 153.202 63.4565 153.153 63.4925C153.04 63.5885 152.926 63.6815 152.824 63.7885C152.776 63.8385 152.714 63.8725 152.669 63.9275C152.615 63.9935 152.58 64.0695 152.534 64.1395C152.029 64.8075 151.719 65.6305 151.719 66.5315C151.719 68.0905 152.623 69.4275 153.927 70.0835C153.509 70.8335 153.251 71.6855 153.251 72.6045C153.251 75.4865 155.587 77.8225 158.469 77.8225C160.514 77.8225 162.266 76.6345 163.122 74.9215C163.33 74.9495 163.541 74.9655 163.757 74.9655C166.574 74.9655 168.858 72.6815 168.858 69.8655C168.858 69.7875 168.838 69.7155 168.835 69.6385C172.984 71.6635 180.725 72.2945 185.489 69.3065C185.501 68.9415 185.496 68.5815 185.476 68.2265C187.922 67.4085 189.689 65.1025 189.689 62.3795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.315 212.501C137.095 213.081 129.085 211.911 124.265 207.731C121.215 205.081 119.185 199.701 118.055 192.781C127.515 193.521 142.285 197.181 146.315 212.501Z",
    fill: "#802223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.438 188.281L288.302 138.415C290.112 135.287 293.453 133.361 297.067 133.361H343.576C346.155 133.361 347.766 136.155 346.474 138.387L317.593 188.281",
    fill: "#D390BB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifthCard);
export default __webpack_public_path__ + "static/media/fifth-card.98716b5c1accfb408e51658228f13ee4.svg";
export { ForwardRef as ReactComponent };